import { StringTMap } from '@@types/common';
import Hook from '@@types/Hook';

import { action, observable } from 'mobx';
import { isNil } from 'ramda';

class IncomingHookStore {
  @observable
  hookMap: StringTMap<StringTMap<Hook>> = {};

  @action
  addHook = (channelId: string, hook: Hook) => {
    if (isNil(this.hookMap[channelId])) {
      this.hookMap[channelId] = {};
    }
    this.hookMap[channelId][hook.id] = hook;
  };

  getHookMap = (channelId: string) => {
    return this.hookMap[channelId];
  };

  getHook = (channelId: string, hookId: string) => {
    return this.getHookMap(channelId)[hookId];
  };

  @action
  removeHook = (channelId: string, hookId: string) => {
    delete this.hookMap[channelId][hookId];
  };

  @action
  setHookMap = (channelId: string, hookMap: StringTMap<Hook>) => {
    this.hookMap[channelId] = hookMap;
  };

  @action
  updateHook = (channelId: string, hook: Hook) => {
    this.hookMap[channelId][hook.id] = hook;
  };
}

export default IncomingHookStore;

export const incomingHooksStore = new IncomingHookStore();
